module.exports = __webpack_public_path__ + "static/media/project3.cd94e699.jpg";